<template>
    <div class="container">
      <div class="section">
        <div class="box">
            <AddPlugin/>
        </div>
      </div>
    </div>
</template>

<script>
import AddPlugin from "../components/add/AddPlugin";

export default {
    components: {
        AddPlugin,
    },
}
</script>